// ABOUTME: Factory for creating Cloudflare backend provider
// ABOUTME: Bundles auth provider into BackendProvider

import type { BackendProvider } from '../interfaces'
import { CloudflareAuthProvider } from './auth'

export interface CloudflareConfig {
  apiUrl: string
}

export function createCloudflareProvider(config: CloudflareConfig): BackendProvider {
  return {
    auth: new CloudflareAuthProvider(config.apiUrl),
  }
}
